import { DocumentIcon } from '@/components/icons/DocumentIcon';
import { UploadImageIcon } from '@/components/icons/UploadImageIcon';

export type FileIconDislayProps = {
  isImage: boolean;
};

export default function FileIconDisplay({ isImage }: FileIconDislayProps) {
  return isImage ? (
    <UploadImageIcon className="w-5 h-5 flex-shrink-0 text-[#000000]" />
  ) : (
    <DocumentIcon className="w-5 h-5 flex-shrink-0 text-[#000000]" />
  );
}
